import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Row, Tooltip, Typography } from 'seagull';
import { presetMappingStatusFor } from '~/features/salesTax/presets';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { AccountingMappingIcon } from '~/integrations/Accounting/AccountingMappingIcon';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import { Accounting } from '~/types/api.model';
const STATUS_INTENT = {
    mapped: 'success',
    partial: 'partial',
    unmapped: 'pending'
};
export const PresetMappingStatus = (param)=>{
    let { preset } = param;
    const { t } = useLocaleKeys('pages.salesTaxSettings.ratesSection.mappingStatus');
    const showQboIntegration = useStore(selectors.integration.showQboIntegration);
    const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
    const connected = [
        ...showQboIntegration ? [
            {
                integrationName: 'qbo',
                accounting: Accounting.QBO
            }
        ] : [],
        ...showXeroIntegration ? [
            {
                integrationName: 'xero',
                accounting: Accounting.Xero
            }
        ] : []
    ];
    return /*#__PURE__*/ _jsx(Row, {
        gap: 4,
        justifyContent: "center",
        style: {
            paddingRight: 32
        },
        children: connected.map((param)=>{
            let { integrationName, accounting } = param;
            const status = presetMappingStatusFor(preset, integrationName);
            const integration = getAccountingDetails(accounting).fullName;
            return /*#__PURE__*/ _jsx(Tooltip, {
                placement: "top",
                title: /*#__PURE__*/ _jsx(Typography, {
                    skin: "invertedStandard",
                    children: t[status]({
                        integration
                    })
                }),
                children: /*#__PURE__*/ _jsx(IconButton, {
                    bi: {
                        name: 'sales_tax_preset_mapping_status'
                    },
                    cursorDefault: true,
                    skin: "transparent",
                    size: "small",
                    noPadding: true,
                    children: /*#__PURE__*/ _jsx(AccountingMappingIcon, {
                        intent: STATUS_INTENT[status]
                    })
                })
            }, integrationName);
        })
    });
};
